import { ChangeDetectionStrategy,Component, inject, OnInit } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CoreModule } from '@shared/lib/modules/core.module';
import { DeploymentStore } from '@shared/lib/stores/deployment.store';
import { NotificationStore } from '@shared/lib/stores/notification.store';
import { UserStore } from '@shared/lib/stores/user.store';
import { SideBarComponent } from '@web-app/app/components/layout/sidebar/sidebar.component';
import { AppLoadingNotification } from '@web-app/app/interfaces/app-loading-notification';
import { TenantService } from '@web-app/app/services/tenants/tenant.service';
import { FilterMatchMode } from 'primeng/api';
import { PrimeNG } from 'primeng/config';

@Component({
    selector: 'ods-root',
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CoreModule, RouterOutlet, SideBarComponent]
})
export class AppComponent implements OnInit {
  userStore = inject(UserStore);
  deploymentStore = inject(DeploymentStore);
  notificationStore = inject(NotificationStore);

  tenantService = inject(TenantService);
  translate = inject(TranslateService);
  primeng = inject(PrimeNG);
  router = inject(Router);

  title = 'cloudOTDR';
  prevAuthStatus = false;
  notificationList = toObservable<AppLoadingNotification | null>(this.notificationStore.notificationData);

  constructor() {
    this.translate.setFallbackLang('en');
    this.loadCoreData();
  }

  ngOnInit() {
    this.primeng.filterMatchModeOptions = {
      text: [FilterMatchMode.STARTS_WITH, FilterMatchMode.CONTAINS, FilterMatchMode.NOT_CONTAINS, FilterMatchMode.ENDS_WITH, FilterMatchMode.EQUALS, FilterMatchMode.NOT_EQUALS],
      numeric: [FilterMatchMode.EQUALS, FilterMatchMode.NOT_EQUALS, FilterMatchMode.LESS_THAN, FilterMatchMode.LESS_THAN_OR_EQUAL_TO, FilterMatchMode.GREATER_THAN, FilterMatchMode.GREATER_THAN_OR_EQUAL_TO],
      date: [FilterMatchMode.DATE_IS, FilterMatchMode.DATE_IS_NOT, FilterMatchMode.DATE_BEFORE, FilterMatchMode.DATE_AFTER],
    };
  }

  loadCoreData() {
    toObservable(this.userStore.isAuthenticated).subscribe((isAuthenticated) => {
      if (isAuthenticated && !this.prevAuthStatus) {
        this.tenantService.initialize();
        this.prevAuthStatus = isAuthenticated;
        this.translate.setFallbackLang(this.userStore.displayLanguage());
      }
    });
  }

  logout() {
    this.userStore.clear();
    this.deploymentStore.clear();
    this.prevAuthStatus = false;
    this.router.navigate(['/account/login']);
  }
}
